// import base from "../../../common/base";
export default {
  shukkaHikiWatashiItems: (state) => state.shukkaHikiWatashiItems,
  commentItems: (state) => state.commentItems,
  searchConditions: (state) => state.searchConditions,
};
